// extracted by mini-css-extract-plugin
module.exports = {"root":"PlainOverlay-module--root--3tJAj utils--layoutFullFixed--3gxY4"};